module.exports = __webpack_public_path__ + "img/font-icon-Enerdata.c2c8190.svg";